export default defineNuxtPlugin(() => {
  const { public: pub } = useRuntimeConfig();
  const pixelId = String(pub.metaPixelId || "").trim();

  // Do not run if Pixel ID is not configured
  if (!pixelId) return;

  // Enable Meta Pixel ONLY on production domain
  const allowedHosts = new Set(["mulberryss.shop", "www.mulberryss.shop"]);
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  if (!allowedHosts.has(host)) {
    // Do not load pixel on localhost / staging
    return;
  }

  const safeTrack = (
    eventName: string,
    params?: Record<string, any>,
    options?: Record<string, any>,
  ) => {
    try {
      // @ts-expect-error fbq is injected on window
      window.fbq("track", eventName, params || undefined, options || undefined);
    } catch (e) {
      // Never break UX because of analytics
      console.warn(`Meta Pixel ${eventName} failed`, e);
    }
  };

  // Provide a tiny API for the rest of the app
  const nuxtApp = useNuxtApp();
  nuxtApp.provide("metaPixel", {
    track: safeTrack,
  });

  // Defer the heavy script load to idle time so it doesn't block hydration / TBT
  const scheduleIdle =
    typeof requestIdleCallback === "function"
      ? requestIdleCallback
      : (cb: () => void) => setTimeout(cb, 2000);

  scheduleIdle(() => {
    // Load Meta Pixel base script (official vendor snippet — keep verbatim)
    /* eslint-disable no-unused-expressions, @typescript-eslint/no-unused-expressions, prefer-spread, prefer-rest-params */
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js",
    );
    /* eslint-enable no-unused-expressions, @typescript-eslint/no-unused-expressions, prefer-spread, prefer-rest-params */

    // Init
    try {
      // @ts-expect-error fbq is injected on window
      window.fbq("init", pixelId);
    } catch (e) {
      console.warn("Meta Pixel init failed", e);
      return;
    }

    // First view (deferred)
    safeTrack("PageView");
  }); // end scheduleIdle

  const router = useRouter();

  // SPA navigation
  router.afterEach(() => {
    safeTrack("PageView");
  });
});
